<template>
  <div class="container">
    <JOnlineCode
      :language="language"
      :inputCode="inputCode"
      v-model="inputContent"
      :projectId="projectId"
      :env="env"
      :isVertical="isVertical"
      :title="title"
      :showDownload="showDownload"
      @success="success"
      @failed="failed"
    />
    <!-- <div class="bottom-area" v-if="showOutInput">
      <el-input
        class="mt-12"
        type="textarea"
        :autosize="{ minRows: 2 }"
        placeholder="请输入运行答案"
        v-model="answerContent"
        :disabled="disabled"
      >
      </el-input>
    </div> -->
  </div>
</template>

<script>
import { JOnlineCode } from "jiker-online-code";
const env = process.env.NODE_ENV == "development" ? "vip" : "prod";
export default {
  components: {
    JOnlineCode
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    language: {
      type: String,
      default: "python"
    },
    inputCode: {
      type: String,
      default: ""
    },
    projectId: {
      type: String,
      default: ""
    },
    isVertical: {
      type: Boolean,
      default: true
    },
    showDownload: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: "练习"
    },
    answer: {
      type: String,
      default: ""
    },
    showOutInput: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      answerContent: null,
      inputContent: null,
      env: env
    };
  },
  watch: {
    answer: {
      handler(val) {
        this.answerContent = val;
      },
      immediate: true
    },
    answerContent(val) {
      this.$emit("update:answer", val);
    },
    value(val) {
      this.inputContent = val;
    },
    inputContent(val) {
      this.$emit("update:inputCode", val);
    }
  },
  methods: {
    success(res) {
      this.$emit("update:outputCode", res.data);
    },
    failed() {
      this.$message.error("运行错误，请检查输入是否正确");
    }
  }
};
</script>

<style lang="less" scoped>
.bottom-area {
  background: #161718;
  padding-bottom: 12px;
  padding-right: 12px;
  display: flex;
  justify-content: space-between;
}
.container {
  height: 100%;
}
</style>
